export default "__VITE_ASSET__B4gwWQ9S__"